export interface IBaseParameter { }
export class BaseParameter {
  /**
   *
   */
  constructor(opt: IBaseParameter = {}) {
    Object.keys(opt).forEach(key => this[key] = opt[key]);
  }
}


// WEBPACK FOOTER //
// ./src/models/base.parameter.ts